import clsx from "clsx";
import type { EnrolmentStatus } from "../types";

const STATUS_CONFIG: Record<EnrolmentStatus, { label: string; className: string }> = {
  CONFIRMED: {
    label: "Confirmed",
    className: "bg-green-100 text-green-800 border border-green-200 dark:bg-green-900/40 dark:text-green-300 dark:border-green-800",
  },
  PENDING: {
    label: "Pending",
    className: "bg-yellow-100 text-yellow-800 border border-yellow-200 dark:bg-yellow-900/40 dark:text-yellow-300 dark:border-yellow-800",
  },
  DECLINED: {
    label: "Declined",
    className: "bg-red-100 text-red-800 border border-red-200 dark:bg-red-900/40 dark:text-red-300 dark:border-red-800",
  },
};

export function StatusBadge({ status }: { status: EnrolmentStatus }): JSX.Element {
  const config = STATUS_CONFIG[status];
  return <span className={clsx("badge", config.className)}>{config.label}</span>;
}
